import React from "react";

import {
  Box,
  Button,
  InputBase,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import { colors } from "../configs";

const StyledButton = styled(Button)({
  height: "100%",
  padding: "10px",
  margin: "0px 2px",
  backgroundColor: "#000000",
  color: "#FFFFFF",

  "&: hover": {
    backgroundColor: "#FFFFFF",
    color: "#000000",
  },
});
const SubscribeSection = () => {
  return (
    <Box
      sx={{
        display: "flex",
        margin: "40px 0px",
        flexDirection: "column",
        justifyContent: "space-evenly",
        alignItems: "center",
        gap: 3,
      }}>
      <Typography
        variant="h4"
        sx={{
          color: "#3B82F6",
        }}>
        Teksa travel corporate
      </Typography>
      <Box>
        {/* 
                <Paper
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            padding: "2px",
          }}>
          <Paper>
            <WbSunnyIcon />
          </Paper>
          <Paper>
            <DarkModeOutlinedIcon />
          </Paper>
        </Paper>
        */}
      </Box>
      <Paper
        component="form"
        sx={{
          padding: "5px 5px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          width: 400,
          marginBottom: "50px",
          backgroundColor: colors.main,
          borderRadius: "5px",
          gap: 2,
        }}>
        <InputBase
          sx={{ ml: 1, flex: 1, color: "#FFFFFF", fontWeight: "bold" }}
          placeholder="Type your email here"
          inputProps={{ "aria-label": "Type your email here" }}
        />
        <StyledButton variant="contained" type="button" aria-label="Subscribe">
          Subscribe
        </StyledButton>
      </Paper>
    </Box>
  );
};

export default SubscribeSection;
